import React, {Children, cloneElement, useState} from "react";

import Modal, {ModalProps} from "./Modal";

export type ModalTriggerProps = Omit<ModalProps, "isOpen" | "onClose"> & {
  children: JSX.Element;
  modalComponent: React.ElementType;
  isInitiallyOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  // any other props
  [x: string]: any;
};

export default function ModalTrigger({
  children,
  isInitiallyOpen = false,
  onOpen,
  onClose,
  ...otherProps
}: ModalTriggerProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(isInitiallyOpen);

  const handleClose = () => {
    setIsOpen(false);
    onClose?.();
  };

  const handleOpen = () => {
    setIsOpen(true);
    onOpen?.();
  };

  // ensure that we have only one child (control element)
  const child = cloneElement(Children.only(children), {
    onClick: handleOpen,
    key: "modal-control",
  });

  return (
    <>
      {child}
      <Modal
        {...otherProps}
        isOpen={isOpen}
        key="modal-dialog"
        onClose={handleClose}
      />
    </>
  );
}
